import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// Ventas de un día (productos + ventas libres), en una sola lista ordenada por
// hora. `soloDe`: id de usuario para ver solo lo que esa persona vendió.
// fecha: 'YYYY-MM-DD' (día local).
export async function obtenerVentasDelDia(fecha, soloDe = null) {
  const neg = getNegocioId();
  const [a, m, d] = fecha.split('-').map(Number);
  const desde = new Date(a, m - 1, d);
  const hasta = new Date(a, m - 1, d + 1);

  let qv = supabase.from('ventas')
    .select('id, nombre_producto, codigo_producto, cantidad, total, costo_unitario, metodo_pago, vendido_en, vendido_por, a_credito, ticket_id')
    .eq('negocio_id', neg).gte('vendido_en', desde.toISOString()).lt('vendido_en', hasta.toISOString());
  let qi = supabase.from('ingresos_libres')
    .select('id, concepto, monto, costo, metodo_pago, creado_en, usuario_id, ticket_venta, envio')
    .eq('negocio_id', neg).eq('fecha', fecha);
  if (soloDe) { qv = qv.eq('vendido_por', soloDe); qi = qi.eq('usuario_id', soloDe); }

  const [rv, ri] = await Promise.all([qv, qi]);
  if (rv.error) throw rv.error;
  if (ri.error) throw ri.error;

  const filas = [
    ...(rv.data || []).map((v) => ({
      id: `v-${v.id}`, hora: v.vendido_en, tipo: 'producto',
      descripcion: `${v.nombre_producto || 'Producto'}${Number(v.cantidad) !== 1 ? ` × ${Number(v.cantidad)}` : ''}`,
      monto: Number(v.total || 0),
      costo: Number(v.costo_unitario || 0) * Number(v.cantidad || 0),
      metodo: v.a_credito ? 'Crédito' : v.metodo_pago, quien: v.vendido_por,
      ticket: v.ticket_id || null,
    })),
    ...(ri.data || []).map((i) => ({
      id: `i-${i.id}`, hora: i.creado_en, tipo: 'libre',
      descripcion: i.concepto || 'Venta libre',
      monto: Number(i.monto || 0), costo: Number(i.costo || 0),
      metodo: i.metodo_pago, quien: i.usuario_id,
      // El envío que se cobra junto a una venta pertenece a ese ticket: no es otra venta.
      ticketVenta: i.ticket_venta || null,
      envio: !!i.ticket_venta || i.concepto === 'Envío nacional' || Number(i.envio || 0) > 0,
    })),
  ];
  return filas.sort((x, y) => new Date(y.hora) - new Date(x.hora));
}
